import { render, staticRenderFns } from "./update-pswd.vue?vue&type=template&id=a649ebb4&scoped=true&"
import script from "./update-pswd.vue?vue&type=script&lang=js&"
export * from "./update-pswd.vue?vue&type=script&lang=js&"
import style0 from "./update-pswd.vue?vue&type=style&index=0&id=a649ebb4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a649ebb4",
  null
  
)

export default component.exports